export enum TimeUnit {
  Minute = `minute`,
  Hour = `hour`,
  Day = `day`,
  Week = `week`,
  Month = `month`,
  Quarter = `quarter`,
  Year = `year`,
}

export enum SpecialTimeUnit {
  HourOfDay = `hour_of_day`,
  DayOfWeek = `day_of_week`,
}

export enum TimeUnitLabels {
  minute = `Minute`,
  hour = `Hour`,
  day = `Day`,
  week = `Week`,
  month = `Month`,
  quarter = `Quarter`,
  year = `Year`,
  hour_of_day = `Hour of Day`, // eslint-disable-line @typescript-eslint/camelcase
  day_of_week = `Day of Week`, // eslint-disable-line @typescript-eslint/camelcase
}

export interface RelativeDate {
  unit: TimeUnit;
  value: number;
}

/** format: "YYYY-MM-dd" */
export type AbsoluteDate = string;

export type BaseDate = AbsoluteDate | RelativeDate;

export interface ApiDateRange {
  before?: boolean;
  from_date?: BaseDate;
  to_date?: BaseDate;
  window?: RelativeDate;
}

export interface BookmarkDateRange {
  type: DateRangeType;
  from_date: BaseDate;
  to_date: BaseDate;
}

export interface CalendarDateRange {
  from?: AbsoluteDate;
  to?: AbsoluteDate;
}

export enum DateRangeType {
  Between = `between`,
  NotBetween = `not between`,
  On = `on`,
  NotOn = `not on`,
  RelativeAfter = `in the last`,
  RelativeBefore = `before the last`,
  Since = `since`,
  StartsOn = `starts on`,
  EndsOn = `ends on`,
}

export enum DisplayContext {
  Default = `default`,
  FullLength = `full_length`,
  ImpactTimePicker = `impact_time_picker`,
  InsightsTimePicker = `insights_time_picker`,
  PropertyFilter = `property_filter`,
  RelativeRange = `relative_range`,
}
